import exportToCsv from '../../../utils/exportToCsv.js';

export function exportDataQualityCsv(tableRows = []) {
  const headerMap = {
    ReadingDate: 'Date',
    Missing_Type7: 'Missing (Infill)',
    Actual: 'Actual',
    Missing_Type9: 'Missing (Provided)',
    Uncertain: 'Uncertain',
    PendingMissing: 'Pending',
    Percent_Missing_Type7: '% Missing (Infill)',
    Percent_Actual: '% Actual',
    Percent_Missing_Type9: '% Missing (Provided)',
    Percent_Uncertain: '% Uncertain',
    Percent_PendingMissing: '% Pending',
  };

  const rows = (Array.isArray(tableRows) ? tableRows : []).map((r) => ({
    ReadingDate: r.ReadingDate ? new Date(r.ReadingDate).toLocaleDateString('en-GB') : '',
    Missing_Type7: Number(r.Missing_Type7) || 0,
    Actual: Number(r.Actual) || 0,
    Missing_Type9: Number(r.Missing_Type9) || 0,
    Uncertain: Number(r.Uncertain) || 0,
    PendingMissing: Number(r.PendingMissing) || 0,
    Percent_Missing_Type7: Number(r.Percent_Missing_Type7) || 0,
    Percent_Actual: Number(r.Percent_Actual) || 0,
    Percent_Missing_Type9: Number(r.Percent_Missing_Type9) || 0,
    Percent_Uncertain: Number(r.Percent_Uncertain) || 0,
    Percent_PendingMissing: Number(r.Percent_PendingMissing) || 0,
  }));

  const ts = new Date().toISOString().replace(/[-:]/g, '').replace(/\..+/, '').replace('T', '_');
  exportToCsv(`data_quality_${ts}.csv`, rows, headerMap);
}